import { useState, useEffect } from 'react';
import { supabase } from './supabase';

export const useProfile = (userId) => {
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!userId) {
      setProfile(null);
      setLoading(false);
      return;
    }

    const loadProfile = async () => {
      setLoading(true);
      const { data, error } = await supabase
        .from('profiles')
        .select('role, branch_id, display_name, organization_id, branches(nombre)')
        .eq('id', userId)
        .single();

      if (error || !data) {
        console.error('Error loading profile:', error);
        setProfile(null);
      } else {
        setProfile({
          role: data.role,
          branchId: data.branch_id,
          branchName: data.branches?.nombre || null,
          displayName: data.display_name,
          organizationId: data.organization_id
        });
      }
      setLoading(false);
    };

    loadProfile();
  }, [userId]);

  const isAdmin = profile?.role === 'admin' || profile?.role === 'supervisor';
  const isGestor = profile?.role === 'gestor';
  // Stricter than isAdmin -- excludes supervisor. Only for gating the
  // God View audit log, which even Manuel shouldn't see.
  const isSuperAdmin = profile?.role === 'admin';

  return { profile, loading, isAdmin, isGestor, isSuperAdmin };
};
